<template>
    <div class="st-main-content">
        <div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:loading="false"
                :showPage="togglePage"
                :pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr"
                @selectionChange="selectionChange"
				@sizeChange="sizeChange"
				>
                    <template slot="beginTm" slot-scope="scope">
                        <span>{{$util.dateUtil.formatTime(scope.row.beginTm) }}</span>
                    </template>
                    <template slot="endTm" slot-scope="scope">
                        <span>{{$util.dateUtil.formatTime(scope.row.endTm) }}</span>
                    </template>
			</common-table>
		</div>
        <st-dialog title="充值设置" :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false"
            @saveDialog="saveDialogForm">
            <div class="st-dialog-content">
                <ul class="st-dialog-form clearfix">
                    <li>
                        <div class="st-dialog-item-title">开始日期</div>
                        <div class="st-dialog-item-input">
                            <el-date-picker
                                v-model="curModifyObj.beginTm"
                                type="date"
                                placeholder="选择开始时间"
                                class="setTimePicker"
                                >
                              </el-date-picker>
                        </div>
                    </li>
                    <li>
                        <div class="st-dialog-item-title">结束日期</div>
                        <div class="st-dialog-item-input">
                                <el-date-picker
                                v-model="curModifyObj.endTm"
                                type="date"
                                placeholder="选择结束时间"
                                class="setTimePicker"
                                >
                              </el-date-picker>
                        </div>
                    </li>

                </ul>
                <ul class="st-dialog-form clearfix">
                    <li>
                        <div class="st-dialog-item-title">充值金额</div>
                        <div class="st-dialog-item-input">
                            <input type="number" v-model="curModifyObj.rechargeAmount">
                        </div>
                    </li>
                    <li>
                        <div class="st-dialog-item-title">赠送金额</div>
                        <div class="st-dialog-item-input">
                            <input type="number" v-model="curModifyObj.donationAmount">
                        </div>
                    </li>

                </ul>
                <ul class="st-dialog-form clearfix">
                    <li>
                        <div class="st-dialog-item-title">备注</div>
                        <div class="st-dialog-item-input">
                            <input type="text" v-model="curModifyObj.remark">
                        </div>
                    </li>
                    <li>
                        <div class="st-dialog-item-title">状态</div>
                        <div class="st-dialog-item-input">
                            <el-select v-model="curModifyObj.status" placeholder="请选择" class="stSetSelect">
                                <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </li>
                </ul>
            </div>
        </st-dialog>
    </div>
</template>
<script>
    import stDialog from '../../components/StDialog'
    export default {
        name: 'PlatformSetting',
        props: [],
        components: { stDialog },
        data() {
            return {
                tableColumns:[
                    {
                        key: '',
                        title: '操作',
                        align:'center',
                        operate:true,
                        width:'100',
                        setBtns:(row,index)=>{
                            return [
                                {
                                    label:'修改',
                                    handler: (row,index) => this.modify(row)
                                }
                            ]
                        }
                    },{
						slotName:'beginTm',
						slot:true,
						title: '活动开始时间',
                    },{
                        slotName:'endTm',
                        slot:true,
                        title:'活动结束时间',
                        align:'center',
                    },{
                        key:'rechargeAmount',
                        title:'充值金额',
                        align:'center',
                    },{
                        key:'donationAmount',
                        title:'赠送金额',
                        align:'center',
                    },{
                        key:'remark',
                        title:'备注',
                        align:'center',
                    },{
                        key:'statusDesc',
                        title:'状态',
                        align:'center',
                    }
                ],
                bottomHandleArr:[
                    {
                        label: '新增',
                        handler: () => this.add()
                    }
                ],
                pageConfig: {
                    total: 0,
                    pageSize: 100,
                    currentPage: 1,
                    layout: "total, sizes",
                },
                toggleStDialog: false,//控制弹窗
                dataList: [],
                selectedList: [],
                togglePage: false, //是否显示分页
                statusList: [
                    {
                        value: 0,
                        label: '未启用'
                    },
                    {
                        value: 1,
                        label: '启用'
                    },
                    {
                        value: 2,
                        label: '软删'
                    },
                ],
                curModifyObj: {
                    beginTm: '',
                    endTm: '',
                    donationAmount: '',
                    rechargeAmount: '',
                    remark: '',
                    status: '',
                    id: ''
                }
            }
        },
        created() { },
        methods: {
            sizeChange(size) {
                this.pageConfig.currentPage = 1
                this.pageConfig.pageSize = size
                this.getData()
                console.log(1)
            },
            selectionChange(row){
                this.selectedList = row;
            },
            modify(row) {
                this.curModifyObj =  JSON.parse(JSON.stringify(row))
                this.toggleStDialog = true
            },
            add() {
                this.curModifyObj = {
                    beginTm: '',
                    endTm: '',
                    donationAmount: '',
                    rechargeAmount: '',
                    remark: '',
                    status: '',
                    id: ''
                }
                this.toggleStDialog = true
            },
            saveDialogForm() {
                if(!this.curModifyObj.beginTm){
                    this.$toast.stMessage('请选择开始日期',true)
                    return;
                }

                if(!this.curModifyObj.endTm){
                    this.$toast.stMessage('请选择结束日期',true)
                    return;
                }

                if(!this.curModifyObj.donationAmount){
                    this.$toast.stMessage('请输入赠送金额',true)
                    return;
                }

                if(!this.curModifyObj.rechargeAmount){
                    this.$toast.stMessage('请输入充值金额',true)
                    return;
                }

                if(this.curModifyObj.status === ''){
                    this.$toast.stMessage('请选择状态',true)
                    return;
                }
                this.curModifyObj.beginTm = new Date(Number(this.curModifyObj.beginTm)).getTime()
                this.curModifyObj.endTm = new Date(Number(this.curModifyObj.endTm)).getTime()
                this.curModifyObj.donationAmount = Number(this.curModifyObj.donationAmount)
                this.curModifyObj.rechargeAmount = Number(this.curModifyObj.rechargeAmount)
                if (this.curModifyObj.id) {
                    // 修改
                    this.$server.system.changeByRechargeActivity(this.curModifyObj, res => {
                        this.$toast.stMessage('修改成功',true)
					    this.getData();
                    })
                } else {
                    // 修改
                    this.$server.system.addRechargeActivity(this.curModifyObj, res => {
                        this.$toast.stMessage('新增成功',true)
					    this.getData();
                    })
                }

                this.toggleStDialog = false


            },
            getData() {
                let data = {}
                data.size = this.pageConfig.pageSize;
			    data.current = this.pageConfig.currentPage;
                this.$server.system.queryRechargeActivity(data, res => {
                    this.dataList = res.data.records;
                    this.pageConfig.total = res.data.total;
                    this.pageConfig.currentPage = res.data.current;
                    if(res.data.total>0){
                        this.togglePage=true;
                    }
                })
            },
            setList(configKey) {
                this.toggleStDialog = true;
                this.configKey = configKey;
            },
            cellClass(row) {
                if (row.columnIndex === 0) {
                    return 'disabledCheck'
                }
            },
        },
        activated() {
            this.getData()
        },
    }

</script>
<style scoped>
    .platform-setting {
        width: 100%;
        height: auto;
    }

    .query-setting-box-left {
        flex-grow: 0;
    }

    .platform-set-title {
        color: #B5B5B5;
        padding-left: 8px;
        padding-top: 24px;
        font-weight: 600;
    }

    .createStartTime {
        display: inline-block;
        width: 90px;
        height: 22px;
        line-height: 22px;
        background-color: #32BB57;
        color: #fff;
        padding-left: 4px;
        border-radius: 2px 2px 0px 0px;
    }

    .createStartTime i,
    .creatEndTime i {
        display: inline-block;
        width: 12px;
        height: 12px;
        background: url('../../assets/images/icon_select.png') center no-repeat;
        background-size: 100% 100%;
        margin-left: 12px;
        vertical-align: middle;
    }

    .creatEndTime {
        display: inline-block;
        width: 90px;
        height: 22px;
        line-height: 22px;
        background-color: #FF5B3E;
        color: #fff;
        padding-left: 4px;
        border-radius: 2px 2px 0px 0px;
    }

    /* 弹窗内 */
    /*  */
    .st-dialog-content {
        min-height: 200px;
        padding: 0 32px;
    }

    .st-dialog-form {
        width: 406px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .st-dialog-form li {
        width: 156px;
        padding: 13px 0;
    }

    .st-dialog-form li:nth-child(even) {
        float: right;
    }

    .st-dialog-form li:nth-child(odd) {
        float: left;
    }

    .st-dialog-form .st-dialog-item-title {
        height: 20px;
        line-height: 20px;
    }

    .st-dialog-form .st-dialog-item-title i {
        color: #FF5B3E;
    }

    .st-dialog-form .st-dialog-item-input input {
        width: 156px;
        height: 30px;
        text-indent: 8px;
        border-radius: 2px;
        border: 1px solid #DCDCDC;
        box-sizing: border-box;
    }

    .setConfig {
        cursor: pointer;
    }

    .stMbgc.success {
        background-color: seagreen;
    }

    /* end */
</style>